import {
  findNode,
  getEditorString,
  PlateEditor,
  Value,
} from '@udecode/plate-common';

import {
  ELEMENT_ANCHOR_LINK,
  ELEMENT_INTERLINK,
  ELEMENT_LINK,
  MyAnchorLinkElement,
  MyInterlinkElement,
  MyLinkElement,
} from '../../../plateTypes';
import { floatingLinkActions } from '../hooks/floatingLinksStore';

export const triggerFloatingLinkEdit = <V extends Value>(
  editor: PlateEditor<V>,
): boolean | void => {
  const interlinkEntry = findNode<MyInterlinkElement>(editor, {
    match: { type: ELEMENT_INTERLINK },
  });

  if (interlinkEntry) {
    const [link, path] = interlinkEntry;
    const text = getEditorString(editor, path);
    floatingLinkActions.linkType('article');
    floatingLinkActions.interlinkId(link.linkId);
    floatingLinkActions.interlinkTitle(link.linkTitle);
    floatingLinkActions.text(text);
    floatingLinkActions.url('');
    floatingLinkActions.isEditing(true);
    return true;
  }

  const linkEntry = findNode<MyLinkElement>(editor, {
    match: { type: ELEMENT_LINK },
  });

  if (linkEntry) {
    const [link, path] = linkEntry;
    let text = getEditorString(editor, path);
    floatingLinkActions.linkType('url');
    floatingLinkActions.url(link.url);
    floatingLinkActions.interlinkId('');
    floatingLinkActions.newTab(link.target === '_blank');
    if (text === link.url) {
      text = '';
    }
    floatingLinkActions.text(text);
    floatingLinkActions.isEditing(true);
    return true;
  }

  const elementEntry = findNode<MyAnchorLinkElement>(editor, {
    match: { type: ELEMENT_ANCHOR_LINK },
  });

  if (elementEntry) {
    const [link, path] = elementEntry;
    const text = getEditorString(editor, path);
    floatingLinkActions.linkType('anchor');
    floatingLinkActions.linkedElementId(link.linkId);
    floatingLinkActions.text(text);
    floatingLinkActions.isEditing(true);
    return true;
  }
  return;
};
